import React from "react";
import classNames from "classnames";

// assets
import styles from "@/assets/styles/containers/getting-started/getting-started-progress.module.scss";


interface IGettingStartedProgress {
  progress: number;
  percentage: number;
}

function GettingStartedProgress({ progress, percentage }: IGettingStartedProgress) {
  const getSectionClassName = (index: number) => classNames(
    styles["locl-getting-started-progress__inner__block"],
    {
      [styles["locl-getting-started-progress__inner__block_active"]]: progress === index,
      [styles["locl-getting-started-progress__inner__block_pass"]]: progress > index,
    }
  );

  return (
    <div className={styles["locl-getting-started-progress"]}>
      <div className={styles["locl-getting-started-progress__inner"]}>
        {
          new Array(5).fill(null).map((_, index) => (
            <div key={index} className={getSectionClassName(index + 1)}/>
          ))
        }
      </div>
      <span className={styles["locl-getting-started-progress__hint"]}>{percentage}%</span>
    </div>
  );
}

export default GettingStartedProgress;

